import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'url-search-params-polyfill'
import React from "react"
import ReactDOM from "react-dom"
import { createStore, compose, applyMiddleware } from "redux"
import { Provider } from "react-redux"
import { StyleSheetManager } from 'styled-components'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import createSagaMiddleware from 'redux-saga'
import reducer from "./reducers"
import rootSaga from './sagas'
import App from "./App"
import EstimateSavePopup from "./components/estimate_save/popup"
import EstimateSavePopup2 from "./components/estimate_save/popup2"
import CompareView from "./components/compareview/index"
import ShareURLComponent from "./common/shareURLComponent";

const sagaMiddleware = createSagaMiddleware()
const middlewares = [sagaMiddleware]

const enhancer = process.env.NODE_ENV === 'production'
    ? compose(applyMiddleware(...middlewares))
    : compose(
        applyMiddleware(...middlewares),
        typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : f => f,
    )

const store = createStore(reducer, enhancer)
sagaMiddleware.run(rootSaga)

let isPrerender = false
if (navigator.userAgent.indexOf("Prerender")) {
    isPrerender = true
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <StyleSheetManager disableCSSOMInjection={isPrerender} >
                <BrowserRouter>
                    <Switch>
                        <Route path="/estimateSave/:idx_b_manager/:priceType" component={EstimateSavePopup} />
                        <Route path="/estimateSave2/:idx_b_manager/:priceType" component={EstimateSavePopup2} />
                        <Route path="/compare_spec" component={CompareView}/>
                        {/*<Route path="/est/:estimate_idx" component={App} />*/}
                        <Route path="/est/:estimate_idx" component={ShareURLComponent} />
                        <Route path="/" component={App} />
                    </Switch>
                </BrowserRouter>
            </StyleSheetManager>
        </Provider>
    </React.StrictMode>,
    document.getElementById("containerlist")
)



// WEBPACK FOOTER //
// ./src/estimate_list/index.js